import { PanelRight, Sparkles } from 'lucide-react'

import { useAdvisor } from '../lib/advisor'
import { AdvisorConversation } from './AdvisorConversation'
import { Modal } from './Modal'
import { ReadingSelect, RequestFailure, useActiveReading } from './AdvisorPanel'

export function AdvisorModal() {
  const advisor = useAdvisor()
  const { readings, active, isPending } = useActiveReading()

  return (
    <Modal onClose={advisor.closeModal} className="modal--wide advisor-modal">
      <header className="advisor-modal__header">
        <h3>
          <Sparkles size={18} aria-hidden="true" /> Asesor IA
        </h3>
        <div className="advisor-panel__actions">
          <button
            type="button"
            className="button button--ghost button--small"
            onClick={() => advisor.setDisplayMode('panel')}
          >
            <PanelRight size={14} aria-hidden="true" />
            Acoplar al costado
          </button>
        </div>
        {active && <ReadingSelect readings={readings} active={active} />}
      </header>

      {advisor.isRequesting && (
        <p className="advisor-analyzing" role="status">
          Analizando la flota… puede tardar hasta un minuto
        </p>
      )}
      <RequestFailure />
      {isPending ? (
        <p className="muted">Cargando…</p>
      ) : active ? (
        <AdvisorConversation key={active.id} alert={active} layout="wide" />
      ) : (
        <p className="muted">Todavía no pediste ninguna lectura de la flota.</p>
      )}
    </Modal>
  )
}
